import React from 'react';
import cn from 'classnames';
import { ReactComponent as LoaderIcon } from 'icons/loader.svg';

import s from './Loader.module.css';

const Loader = ({ className }) => <LoaderIcon className={cn(s.root, className)} />;

export default React.memo(Loader);
